import React, { useEffect } from "react";
import { BasicsInfoStyled } from "./basic-info.style";
import ContactInfoForm, {
  Contact_INFO_FORM_VIEW_TYPES,
} from "../../contact-info-form";

const BasicInfo = ({
  contactData,
  isEditMode,
  form,
}) => {
  const { isDirty } = form.formState;

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isEditMode && isDirty) {
        const message = "Hold on! Your changes have not been saved.";
        event.returnValue = message;
        return message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isEditMode, isDirty]);

  return (
    <BasicsInfoStyled>
      <div
        className="contact-form"
        style={{
          pointerEvents: isEditMode ? "" : "none",
          opacity: isEditMode ? "1.0" : "0.7",
        }}
      >
        <ContactInfoForm
          contactData={contactData}
          form={form}
          view={Contact_INFO_FORM_VIEW_TYPES.detail}
        />
      </div>
    </BasicsInfoStyled>
  );
};

export default BasicInfo;
